import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router';
import { setPaymentStatus } from '@entities/exchange';
import { useRouter } from '@shared/lib/router';
const PaymentResult = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const router = useRouter();
    useEffect(() => {
        dispatch(setPaymentStatus(params.status));
    }, []);
    return React.createElement(Redirect, { to: `${router.basePath}/exchange` });
};
export default PaymentResult;
